import { LINE_ITEM_TYPE_FEE } from "../constants/constants";
/**
 * Utility function to check value is there or not - used for display
 * if value exists return value otherwise return dash
 * @param {string} item
 */
export const isValueEmptyCheck = (item) => {
  if (item === undefined || item === "") {
    return '-';
  } else {
    return item;
  }
}

/**
 * Utility function to check value(Currency) is there or not - used for display
 * if value exists return value otherwise return dash
 * @param {string} item
 */
export const isCurrencyValueEmptyCheck = (item) => {
  if (item === undefined || item === "") {
    return '-';
  } else {
    return `$${item}/hr`;
  }
}

/**
* Utility function to check value mandatory form validations
* return boolean
* @param {string} item
*/
export const isValueValid = (item) => {
  let flag = false
  if(item !== undefined && item !== "") {
    flag = true;
  }
  return flag;
}

export const isEmptyObj = (obj) => Object.keys(obj).length === 0;
export const isEmpty = (value) => value === null || value === "null" || value === undefined || value === ""
export const isString = value => typeof value === 'string' || value instanceof String;

/**
 * Time/hours units must be in tenths of an hour (0.1 increments), not values like 0.25 or 10.98.
 * @param {*} units
 * @returns {boolean}
 */
export const isUnitsInTenthsOfHour = (units) => {
  const normalized = String(units ?? "").trim().replace(/[$,\s]/g, "");
  if (normalized === "") return false;
  const n = Number(normalized);
  if (!Number.isFinite(n)) return false;
  const roundedToTenth = Math.round(n * 10) / 10;
  return Math.abs(n - roundedToTenth) < 1e-8;
}

/**
 * Allows empty, digits, optional leading minus, and a single decimal point (commas stripped).
 * Linear scan (no backtracking regex) so malformed input cannot cause ReDoS.
 * @param {*} value
 * @returns {boolean}
 */
export const isAllowedNumericInputValue = (value) => {
  if (value === '' || value === null || value === undefined) return true;
  const normalized = String(value).replace(/,/g, '');
  let i = 0;
  if (normalized.charAt(i) === '-') i += 1;
  let sawDot = false;
  for (; i < normalized.length; i += 1) {
    const c = normalized.charAt(i);
    if (c >= '0' && c <= '9') continue;
    if (c === '.' && !sawDot) {
      sawDot = true;
      continue;
    }
    return false;
  }
  return true;
}

// UTBMS code that starts with AFA
export const tkidRequiredOnlyForUtbmsPattern = /^(AFA)/;

/**
 * Utility function to check if arguments passed are valid
 * @param {*} list
 * @returns
 */
export const isValueValidList = (list) => {
  // Iterate through the list of values
  for (const item of list) {
    // Check if the current value is undefined or null
    if (isEmpty(item)) {
      // If any value is missing, return false
      return false;
    }
  }
  // If all values are present, return true
  return true;
}

/**
 * Utility function to conditionally check if TKID is mandatory for type fee
 * @param {*} type
 * @param {*} utbmsObj
 * @returns
 */
export const isTkidMandatory = (type = "", utbmsObj = "{}") => {
  // Check if utbmsValue is selected
  const utbmsValue = isString(utbmsObj) && JSON.parse(utbmsObj)?.value?.toUpperCase();
  // TKId is mandatory only if type is fee and utbms selected does not start with AFA
  return type?.toLowerCase() === LINE_ITEM_TYPE_FEE && utbmsValue && !tkidRequiredOnlyForUtbmsPattern.test(utbmsValue)
}


